$(document).ready(function () {
    $('.ShippingEstimator__Error').hide();
    $("#search_postcode").on("click", function (e) {
        e.preventDefault();
        var form = $(this).closest('.form');
        var form2 = $(this).closest('.product-form--regular');
        var destinations = {};
        var rate = [];
        var temp = {};
        var pc = form.find('[name="postal_code"]').val();
        var destination = {};
        destination["postal_code"] = pc;
        if(form.data('state') == 'AU') destination["province"] = getStateAu(pc);
        if(form.data('state') == 'IN') destination["province"] = getStateIn(pc);
        if(form.data('state') == 'US') destination["province"] = getStateUs(pc);
        if(form.data('state') == '') destination["province"] = '';
        destination["country"] = form.data('country');
        destinations["destination"] = destination;
        temp = destinations;  
        var items = [];
        var item = $('#productJson').length != 0 ? JSON.parse(JSON.parse(document.getElementById('productJson').textContent)) : JSON.parse(document.getElementById('cartJson').textContent);
        console.log('item',item , typeof item );
        item['quantity'] = $('[name="quantity"]').val();
        items.push(item);
        temp["items"] = items;
        var shop = Shopify.shop;
        rate = temp;
        var html =''; 
        $('#shipping_rates').hide();
        if( form.data('state') != ''){
        var zl =  form.data('state') == 'AU' ? 4 : form.data('state') == 'US' ? 5 : form.data('state') == 'IN' ? 6 : 0;
          var t =  /^\d+$/.test(pc); 
            if(pc.length != zl || t==false) {
            $('.ShippingEstimator__Error').html(form.data('ship_err')).show();
            return false;
          } 
        }
        $.ajax({
          url: "https://sbz.cirkleinc.com/front-widget",
          data: {rate,shop},
          dataType:'JSON',
          crossDomain: true,
          type: "post",
          success: function (srates) {
            if($('#input_postcode').val() == ""){
              $('.ShippingEstimator__Error').html(form.data('ship_err_req')).show();
            }else{
              if(typeof srates.rates == 'undefined') {
                $('.ShippingEstimator__Error').html(form.data('ship_err')).show();
                return false;
              }
              if(srates.rates.length <= 0){
                if($('#input_postcode').val() == ""){ 
                  $('.ShippingEstimator__Error').html(form.data('ship_err')).show();
                }else{
                  $('.ShippingEstimator__Error').html(form.data('ship_err')).show();
                }
              }else{
                html += '<ul>';
                $(srates.rates).each(function(index,val) {
                  $('.ShippingEstimator__Error').hide();
                  html += '<li><span>'+val.service_name +' -  ' + window.formatMoney(val.total_price,wmf)+'</span><br/><span class="shipdesc">'+val.description+'</span></li>' 
                  console.log("s:", val);
                });
                html += '</ul>'
                $('#shipping_rates').html(html).show();
              }
            }
          },
        });
      });
    
    
      function getStateAu(pc) {
        var rang =  {"NSW":[1000,2599,2619,2898,2921,2999],"ACT":[200,299,2600,2618,2900,2920],"VIC":[3000,3999,8000,8999],"QLD":[4000,4999,9000,9999],"SA":[5000,5999],"WA":[6000,6797,6800,6999],"TAS":[7000,7999],"NT":[0800,0999]} ;
        var exp =  {"0872":"NT","2540":"NSW","2611":"ACT","2620":"NSW","3500":"VIC","3585":"VIC","3586":"VIC","3644":"VIC","3707":"VIC","2899":"NSW","6798":"WA","6799":"WA","7151":"TAS"} ;
        if(exp[pc] !== undefined) {
          return exp[pc];
        } else {
          for (var key in rang) {
            if (rang.hasOwnProperty(key)) {
                for(var i = 0; i < Object.keys(rang[key]).length; i+=2) {
                  if ( pc >= rang[key][i] && pc <= rang[key][i+1] ) {
                    return key;
                  }
                }	
            }
          }
        }
        return '';
      }
      
      function getStateUs(zipString) {
        /* Ensure we don't parse strings starting with 0 as octal values */
        const zipcode = parseInt(zipString, 10);
        let st;
        let state;
        /* Code cases alphabetized by state */
        if (zipcode >= 35000 && zipcode <= 36999) {
            st = 'AL';
            state = 'Alabama';
        } else if (zipcode >= 99500 && zipcode <= 99999) {
            st = 'AK';
            state = 'Alaska';
        } else if (zipcode >= 85000 && zipcode <= 86999) {
            st = 'AZ';
            state = 'Arizona';
        } else if (zipcode >= 71600 && zipcode <= 72999) {
            st = 'AR';
            state = 'Arkansas';
        } else if (zipcode >= 90000 && zipcode <= 96699) {
            st = 'CA';
            state = 'California';
        } else if (zipcode >= 80000 && zipcode <= 81999) {
            st = 'CO';
            state = 'Colorado';
        } else if ((zipcode >= 6000 && zipcode <= 6389) || (zipcode >= 6391 && zipcode <= 6999)) {
            st = 'CT';
            state = 'Connecticut';
        } else if (zipcode >= 19700 && zipcode <= 19999) {
            st = 'DE';
            state = 'Delaware';
        } else if (zipcode >= 32000 && zipcode <= 34999) {
            st = 'FL';
            state = 'Florida';
        } else if ( (zipcode >= 30000 && zipcode <= 31999) || (zipcode >= 39800 && zipcode <= 39999) ) {
            st = 'GA';
            state = 'Georgia';
        } else if (zipcode >= 96700 && zipcode <= 96999) {
            st = 'HI';
            state = 'Hawaii';
        } else if (zipcode >= 83200 && zipcode <= 83999) {
            st = 'ID';
            state = 'Idaho';
        } else if (zipcode >= 60000 && zipcode <= 62999) {
            st = 'IL';
            state = 'Illinois';
        } else if (zipcode >= 46000 && zipcode <= 47999) {
            st = 'IN';
            state = 'Indiana';
        } else if (zipcode >= 50000 && zipcode <= 52999) {
            st = 'IA';
            state = 'Iowa';
        } else if (zipcode >= 66000 && zipcode <= 67999) {
            st = 'KS';
            state = 'Kansas';
        } else if (zipcode >= 40000 && zipcode <= 42999) {
            st = 'KY';
            state = 'Kentucky';
        } else if (zipcode >= 70000 && zipcode <= 71599) {
            st = 'LA';
            state = 'Louisiana';
        } else if (zipcode >= 3900 && zipcode <= 4999) {
            st = 'ME';
            state = 'Maine';
        } else if (zipcode >= 20600 && zipcode <= 21999) {
            st = 'MD';
            state = 'Maryland';
        } else if ( (zipcode >= 1000 && zipcode <= 2799) || (zipcode == 5501) || (zipcode == 5544 ) ) {
            st = 'MA';
            state = 'Massachusetts';
        } else if (zipcode >= 48000 && zipcode <= 49999) {
            st = 'MI';
            state = 'Michigan';
        } else if (zipcode >= 55000 && zipcode <= 56899) {
            st = 'MN';
            state = 'Minnesota';
        } else if (zipcode >= 38600 && zipcode <= 39999) {
            st = 'MS';
            state = 'Mississippi';
        } else if (zipcode >= 63000 && zipcode <= 65999) {
            st = 'MO';
            state = 'Missouri';
        } else if (zipcode >= 59000 && zipcode <= 59999) {
            st = 'MT';
            state = 'Montana';
        } else if (zipcode >= 27000 && zipcode <= 28999) {
            st = 'NC';
            state = 'North Carolina';
        } else if (zipcode >= 58000 && zipcode <= 58999) {
            st = 'ND';
            state = 'North Dakota';
        } else if (zipcode >= 68000 && zipcode <= 69999) {
            st = 'NE';
            state = 'Nebraska';
        } else if (zipcode >= 88900 && zipcode <= 89999) {
            st = 'NV';
            state = 'Nevada';
        } else if (zipcode >= 3000 && zipcode <= 3899) {
            st = 'NH';
            state = 'New Hampshire';
        } else if (zipcode >= 7000 && zipcode <= 8999) {
            st = 'NJ';
            state = 'New Jersey';
        } else if (zipcode >= 87000 && zipcode <= 88499) {
            st = 'NM';
            state = 'New Mexico';
        } else if ( (zipcode >= 10000 && zipcode <= 14999) || (zipcode == 6390) || (zipcode == 501) || (zipcode == 544) ) {
            st = 'NY';
            state = 'New York';
        } else if (zipcode >= 43000 && zipcode <= 45999) {
            st = 'OH';
            state = 'Ohio';
        } else if ((zipcode >= 73000 && zipcode <= 73199) || (zipcode >= 73400 && zipcode <= 74999) ) {
            st = 'OK';
            state = 'Oklahoma';
        } else if (zipcode >= 97000 && zipcode <= 97999) {
            st = 'OR';
            state = 'Oregon';
        } else if (zipcode >= 15000 && zipcode <= 19699) {
            st = 'PA';
            state = 'Pennsylvania';
        } else if (zipcode >= 300 && zipcode <= 999) {
            st = 'PR';
            state = 'Puerto Rico';
        } else if (zipcode >= 2800 && zipcode <= 2999) {
            st = 'RI';
            state = 'Rhode Island';
        } else if (zipcode >= 29000 && zipcode <= 29999) {
            st = 'SC';
            state = 'South Carolina';
        } else if (zipcode >= 57000 && zipcode <= 57999) {
            st = 'SD';
            state = 'South Dakota';
        } else if (zipcode >= 37000 && zipcode <= 38599) {
            st = 'TN';
            state = 'Tennessee';
        } else if ( (zipcode >= 75000 && zipcode <= 79999) || (zipcode >= 73301 && zipcode <= 73399) ||  (zipcode >= 88500 && zipcode <= 88599) ) {
            st = 'TX';
            state = 'Texas';
        } else if (zipcode >= 84000 && zipcode <= 84999) {
            st = 'UT';
            state = 'Utah';
        } else if (zipcode >= 5000 && zipcode <= 5999) {
            st = 'VT';
            state = 'Vermont';
        } else if ( (zipcode >= 20100 && zipcode <= 20199) || (zipcode >= 22000 && zipcode <= 24699) || (zipcode == 20598) ) {
            st = 'VA';
            state = 'Virginia';
        } else if ( (zipcode >= 20000 && zipcode <= 20099) || (zipcode >= 20200 && zipcode <= 20599) || (zipcode >= 56900 && zipcode <= 56999) ) {
            st = 'DC';
            state = 'Washington DC';
        } else if (zipcode >= 98000 && zipcode <= 99499) {
            st = 'WA';
            state = 'Washington';
        } else if (zipcode >= 24700 && zipcode <= 26999) {
            st = 'WV';
            state = 'West Virginia';
        } else if (zipcode >= 53000 && zipcode <= 54999) {
            st = 'WI';
            state = 'Wisconsin';
        } else if (zipcode >= 82000 && zipcode <= 83199) {
            st = 'WY';
            state = 'Wyoming';
        } else {
            st = 'none';
            state = 'none';
            console.log('No state found matching', zipcode);
        }
        return st;
      }
      
      function getStateIn(zipcode) { // india
        let st; 
        /* Code cases alphabetized by state */
        if (zipcode >= 744101 && zipcode <= 744304) {
            st = 'AN'; 
        } else if (zipcode >= 507130 && zipcode <= 535594) {
            st = 'AP';
        } else if (zipcode >= 790001 && zipcode <= 792131) {
            st = 'AR';
        } else if (zipcode >= 781001 && zipcode <= 788931) {
            st = 'AS';
        } else if (zipcode >= 813208 && zipcode <= 835325) {
            st = 'JH';
        } else if (zipcode >= 800001 && zipcode <= 855117) {
            st = 'BR';
        } else if (zipcode >= 140119 && zipcode <= 160102) {
            st = 'CH';
        } else if (zipcode >= 490001 && zipcode <= 497778) {
            st = 'CT';
        } else if (zipcode >= 396193 && zipcode <= 396240) {
            st = 'DN';
        } else if (zipcode >= 362520 && zipcode <= 396220) {
            st = 'DD';
        } else if (zipcode >= 110001 && zipcode <= 110097) {
            st = 'DL';
        } else if (zipcode >= 403001 && zipcode <= 403806) {
            st = 'GA';
        } else if (zipcode >= 360001 && zipcode <= 396590) {
            st = 'GJ';
        } else if (zipcode >= 121001 && zipcode <= 136156) {
            st = 'HR';
        } else if (zipcode >= 171001 && zipcode <= 177601) {
            st = 'HP';
        } else if (zipcode >= 180001 && zipcode <= 194404) {
            st = 'JK';
        } else if (zipcode >= 560001 && zipcode <= 591346) {
            st = 'KA';
        } else if (zipcode >= 670001 && zipcode <= 695615) {
            st = 'KL';
        } else if (zipcode >= 682551 && zipcode <= 682559) {
            st = 'LD';
        } else if (zipcode >= 450001 && zipcode <= 488448) {
            st = 'MP';
        } else if (zipcode >= 400001 && zipcode <= 445402) {
            st = 'MH';
        } else if (zipcode >= 795001 && zipcode <= 795159) {
            st = 'MN';
        } else if (zipcode >= 783123 && zipcode <= 794115) {
            st = 'ML';
        } else if (zipcode >= 796001 && zipcode <= 796901) {
            st = 'MZ';
        } else if (zipcode >= 797001 && zipcode <= 798627) {
            st = 'NL';
        } else if (zipcode >= 751001 && zipcode <= 770076) {
            st = 'OR';
        } else if (zipcode >= 533464 && zipcode <= 673310) {
            st = 'PY';
        } else if (zipcode >= 140001 && zipcode <= 160104) {
            st = 'PB';
        } else if (zipcode >= 301001 && zipcode <= 345034) {
            st = 'RT';
        } else if (zipcode >= 737101 && zipcode <= 737139) {
            st = 'SK';
        } else if (zipcode >= 600001 && zipcode <= 643253) {
            st = 'TN';
        } else if (zipcode >= 500001 && zipcode <= 509412) {
            st = 'TG';
        } else if (zipcode >= 799001 && zipcode <= 799290) {
            st = 'TR';
        } else if (zipcode >= 244712 && zipcode <= 263680) {
            st = 'UK';
        } else if (zipcode >= 201001 && zipcode <= 285223) {
            st = 'UP';
        } else if (zipcode >= 700001 && zipcode <= 743711) {
            st = 'WB';
        } else {
            st = 'none';
            state = 'none';
            console.log('No state found matching', zipcode);
        }
        return st;
      }
    });